import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import * as action from '../redux/actions/';
import * as actionLogout from '../../Account/redux/actions';
import { useUser } from './../../../commons/customHooks/Account';
import { useBanner } from './../../../commons/customHooks/Banner';
import { useRecommendVideo } from './../../../commons/customHooks/Album';

import {
  useCharacter,
  useCharacterFavorite,
} from './../../../commons/customHooks/Character';
import { useAwards } from './../../../commons/customHooks/Award';

import { useAward } from './../../../commons/customHooks/Award';
import { usePoint } from './../../../commons/customHooks/GiftBox';

import { useEffect, useState, memo } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';

import MainLayout from '../../../commons/layout/MainLayout/index';

import io from 'socket.io-client';
import IMAGES from '../../../commons/constans/images';
import useCallSocket from '../../../commons/customHooks/useCallSocket';
import HeaderHs1 from '../../../commons/components/Header/headerHs1';

import HomeBanner from './../components/banner';
import HomeAlbum from './../components/album';
import HomeCategory from './../components/category';
import HomeCharacter from './../components/character';
import HomeRecommendedVideo from './../components/recommendedVideo';
import HomeAwards from './../components/awards';
import HomeVoteAward from './../components/voteAward';
import PopComponent from '../../../commons/components/Popup/PopupComponent';
import ListChildren from '../components/listChildren';
import './../components/styles.scss';
import './../../Information/components/styles.scss';
import InterestedContent from '../components/interestedContent';
import API, { ROUTES } from '../../../commons/api/api';
import ROUTERS from '../../../commons/constans/router';
import { priceFormat } from '../../../utils/helpers';
import { resetChooseCoupon } from '../../../pages/Giftbox/redux/actions/index';

import { updateChildrenProfileSuccess } from './../../Account/redux/actions';
import SkeletonLoadingComponent from '../../../commons/components/SkeletonLoading';
import LoadingAward from '../../../commons/components/Award/LoadingAward';
import { ReactComponent as IconNextPage } from '../../../assets/images/icon_nextpage.svg';
import { ReactComponent as IconNextBtnW } from '../../../assets/images/icon_next_btn_w.svg';
import {
  deleteVideoRequest,
  getTimeVideoRenderRequest,
  resetVideoRender,
  updateVideoMergeErrorRequest,
  videoPaymentClearState,
} from '../../Video/redux/actions';
import { useVideoRender } from '../../../commons/customHooks/Video';
import DialogComponent from '../../../commons/components/Modal/DialogComponent';
import { ERROR_MERGE_VIDEO } from '../../../commons/constans/stepVideo';
import Loading from '../../../commons/components/Loading';
import { isAndroid, isIOS } from 'react-device-detect';
import {
  APP_ENV,
  APP_URL_PRODUCTION_VERSION,
  APP_URL_TEST_VERSION,
  APP_URL_VERSION,
} from '../../../commons/constans/app_version';

const HomePageContainer = (props) => {
  const { isProcessingDel } = useSelector((state) => state.videoDetailReducers);
  const { user } = useUser();

  const award_params = useMemo(() => ({ limit: 3, type: 'top' }), []);
  const [award, entries] = useAward(award_params);

  const [bannerParams] = useState({
    type: 'app_main',
  });
  const [banners, isProcessingBanner] = useBanner(bannerParams);
  const [recommend_videos] = useRecommendVideo();
  const [paramVideoRender] = useState({
    relation: ['characterPose', 'videoMessageTemplete'],
  });
  const [videoRender, isProcessingVideoRender] =
    useVideoRender(paramVideoRender);
  // const [ characters ] = useCharacterFavorite(user);
  const paramsListCharacter = useMemo(
    () => ({
      per_page: 0,
    }),
    []
  );
  const [characterModels] = useCharacter(paramsListCharacter);

  const [isStatusMergeVideo, setIsStatusMergeVideo] = useState({
    status: false,
    type: '',
    msg: '',
    btnClose: '취소',
    btnConfirm: '확인',
  });
  const [isCancelMergeVideo, setIsCancelMergeVideo] = useState({
    status: false,
    msg: '',
  });
  const [isLoadingCheckErrVideo, setIsLoadingCheckErrVideo] = useState(true);
  const errors = [
    ERROR_MERGE_VIDEO.DOWNLOAD.type,
    ERROR_MERGE_VIDEO.MERGE_VIDEO.type,
    ERROR_MERGE_VIDEO.SHUT_DOWN_APP.type,
  ];
  const [point] = usePoint();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // let navigate = useNavigate();
  // console.log(navigate,'nnavigatenavigate')
  // let location  = useLocation();

  // const [dataSocketPrivate, setDataSocketPrivate] = useState({});
  // const [dataSocketGlobal, setDataSocketGlobal] = useState({});

  const leftChild = <img src={IMAGES.iconHeaderPrevLeft} />;

  const [popupListChildren, setPopupListChildren] = useState(false);
  const [popupInterestedContent, setPopupInterestedContent] = useState(false);
  const [popupUpdateApp, setPopupUpdateApp] = useState({
    ishow: false,
    url: '',
  });
  const [registerChildren, setRegisterChildren] = useState({
    childrens: [],
    characters: [],
  });

  const handleListChildren = () => {
    setPopupListChildren(false);
  };

  useEffect(() => {
    // if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === APP_ENV.PRODUCTION) {
    let app_version = window.localStorage.getItem('APP_VERSION');
    console.log(122, process.env.REACT_APP_ANDROID_VERSION);
    console.log(122, process.env.REACT_APP_IOS_VERSION);
    if (isAndroid) {
      console.log('Android device app_version', app_version);
      if (
        app_version &&
        app_version === process.env.REACT_APP_ANDROID_VERSION
      ) {
        setPopupUpdateApp({
          ...popupUpdateApp,
          ishow: false,
        });
      } else {
        setPopupUpdateApp({
          ishow: true,
          url:
            process.env.REACT_APP_ENV === APP_ENV.PRODUCTION
              ? APP_URL_PRODUCTION_VERSION.ANDROID
              : APP_URL_TEST_VERSION.ANDROID
        });
      }
    }
    if (isIOS) {
      console.log('IOS device', app_version);
      if (app_version && app_version === process.env.REACT_APP_IOS_VERSION) {
        setPopupUpdateApp({
          ...popupUpdateApp,
          ishow: false,
        });
      } else {
        setPopupUpdateApp({
          ishow: true,
          url:
            process.env.REACT_APP_ENV === APP_ENV.PRODUCTION
            ? APP_URL_PRODUCTION_VERSION.IOS
            : APP_URL_TEST_VERSION.IOS
        });
      }
    }
    if (localStorage.getItem('sign_up')) {
      setPopupListChildren(true);
      localStorage.removeItem('sign_up');
    }
    // setPopupListChildren(true);
    dispatch(resetChooseCoupon());
    //call api check video message
    setTimeout(() => {
      scrollTo(0, 0);
    }, 500);
  }, []);

  useEffect(() => {
    console.log(119, videoRender, user);
    if (!isProcessingVideoRender && videoRender && videoRender.length > 0) {
      if (
        !videoRender[0]?.file_id &&
        (!user?.video_merge_error || user?.video_merge_error === 0)
      ) {
        setIsLoadingCheckErrVideo(true);
        let isCheck = checkUidInLocalStorage(user?.id, false);
        console.log(142, isCheck);
        if (!isCheck) {
          window.nativeCallCheckMergeVideo(user?.id || null);
        } else {
          setIsLoadingCheckErrVideo(false);
        }
      } else {
        setIsLoadingCheckErrVideo(false);
        setIsStatusMergeVideo({
          ...isStatusMergeVideo,
          status: false,
          msg: '',
        });
      }
    } else {
      setIsLoadingCheckErrVideo(false);
    }
  }, [videoRender, isProcessingVideoRender]);

  window.setStatusMergeVideo = function (data) {
    setIsLoadingCheckErrVideo(false);
    console.log(135, data);
    // -TH1: chưa hoàn tất chế tác thư video mà tắt app hoặc bị mất kết nối internet => downloading or merging
    // -TH2: hoàn tất chế tác thư video và lưu vào device và trong quá trình đang upload lên server mà bị tắt app hoặc mất kết nối internet => api save video err
    // -TH3: TH2 nhưng ở device khác => check user_id + type err.

    // DOWNLOAD("download"),
    // MERGE_VIDEO("merge_video"),
    // CALL_API("call_api"),
    // SHUT_DOWN_APP("shutdown_app")

    // DOWNLOAD
    // MERGE_VIDEO
    // SHUT_DOWN_APP
    // CALL_API
    // DEVICE_DIFF
    switch (data) {
      //TH1
      case ERROR_MERGE_VIDEO.DOWNLOAD.type:
        setIsStatusMergeVideo({
          ...isStatusMergeVideo,
          status: true,
          type: ERROR_MERGE_VIDEO.DOWNLOAD.type,
          msg: ERROR_MERGE_VIDEO.DOWNLOAD.msg,
        });
        break;
      //TH1
      case ERROR_MERGE_VIDEO.MERGE_VIDEO.type:
        setIsStatusMergeVideo({
          ...isStatusMergeVideo,
          status: true,
          type: ERROR_MERGE_VIDEO.MERGE_VIDEO.type,
          msg: ERROR_MERGE_VIDEO.MERGE_VIDEO.msg,
        });
        break;
      //TH1
      case ERROR_MERGE_VIDEO.SHUT_DOWN_APP.type:
        setIsStatusMergeVideo({
          ...isStatusMergeVideo,
          status: true,
          type: ERROR_MERGE_VIDEO.SHUT_DOWN_APP.type,
          msg: ERROR_MERGE_VIDEO.SHUT_DOWN_APP.msg,
        });
        break;
      //TH2
      case ERROR_MERGE_VIDEO.CALL_API.type:
        setIsStatusMergeVideo({
          ...isStatusMergeVideo,
          status: true,
          type: ERROR_MERGE_VIDEO.CALL_API.type,
          msg: ERROR_MERGE_VIDEO.CALL_API.msg,
        });
        break;
      case ERROR_MERGE_VIDEO.DEVICE_DIFF.type:
        //TH3
        if (window.reload_app) {
          setIsStatusMergeVideo({
            status: true,
            type: ERROR_MERGE_VIDEO.DEVICE_DIFF.type,
            msg: ERROR_MERGE_VIDEO.DEVICE_DIFF.msg,
            btnClose: '나중에 다시 알림',
            btnConfirm: '다시 보지 않기',
          });
        }
        break;
      default:
        setIsStatusMergeVideo({
          ...isStatusMergeVideo,
          status: false,
          type: '',
          msg: '',
        });
        break;
    }
  };

  useEffect(() => {
    if (popupListChildren || popupInterestedContent) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }, [popupListChildren, popupInterestedContent]);

  // // useCallSocket();
  // useEffect(() => {
  //   console.log("HomeComponent");
  //   // reset state
  //   // dispatch(resetState());
  //   // console.log(socket, 'socket');
  //   //check auth
  //   // socket.on('sphokidz_private-user_7', res => {
  //   //   console.log(res, 'sphokidz_private-user_7 socker');
  //   //   //set state
  //   //   setDataSocketPrivate(res);

  //   //   if (res.data.logout) {
  //   //     dispatch(realTimeLogoutUser());
  //   //   }
  //   // })

  //   // socket.on('sphokidz_global', res => {
  //   //   console.log(res, 'sphokidz_global socker');
  //   //   //set state
  //   //   setDataSocketGlobal(res);
  //   // })
  // });

  const handleOpenQRCode = () => {
    console.log('handleOpenQRCode');
  };

  const nextInterestedContent = (dataChildrens) => {
    setRegisterChildren({
      ...registerChildren,
      childrens: dataChildrens,
    });
    setPopupListChildren(false);
    setPopupInterestedContent(true);
  };

  const submitInterestedContent = (ids) => {
    let registerChildrenTemporary = {
      ...registerChildren,
      characters: ids,
    };

    API.post(ROUTES.API_CUSTOM_INFORMATION, registerChildrenTemporary).then(
      (res) => {
        setPopupInterestedContent(false);

        API.get(ROUTES.API_UPDATE_AUTH_ME).then((response) => {
          let user = response.data.data;
          dispatch(updateChildrenProfileSuccess(user));
        });
      }
    );
  };

  const goToAward = () => {
    navigate(ROUTERS.AWARD);
  };

  const goToGiftboxPoint = () => {
    navigate(ROUTERS.GIFTBOX_POINT);
  };

  const handleClose = (type) => {
    console.log(type, 'type');
    setIsStatusMergeVideo({
      status: false,
      type: '',
      msg: '',
    });
    if (errors.includes(type)) {
      console.log(305, type);

      setIsCancelMergeVideo({
        status: true,
        msg: ERROR_MERGE_VIDEO.DOWNLOAD.msg_cancel,
      });
    } else if (type === ERROR_MERGE_VIDEO.CALL_API.type) {
      console.log(311, ERROR_MERGE_VIDEO.CALL_API.type);
      setIsCancelMergeVideo({
        status: true,
        msg: ERROR_MERGE_VIDEO.CALL_API.msg_cancel,
      });
    } else if (type === ERROR_MERGE_VIDEO.DEVICE_DIFF.type) {
      console.log(317, ERROR_MERGE_VIDEO.DEVICE_DIFF.type);
      if (window.reload_app) {
        window.reload_app = false;
      }
    }
  };

  const handleCloseCancel = () => {
    setIsCancelMergeVideo(false);
    //not show popup

    //call api delete video
    var formData = new FormData();
    formData.append('video_merge_error', 1);
    dispatch(updateVideoMergeErrorRequest(formData));
    // dispatch(resetVideoRender());
    // window.nativeCallRemoveMergeProcess(user?.id || null)
  };

  const checkUidInLocalStorage = (uid, type = false) => {
    let uids = window.localStorage.getItem('id_popup_merge');
    let uidsArr = JSON.parse(uids) || [];
    if (uidsArr && uidsArr.length > 0) {
      let idx = uidsArr.indexOf(uid);
      if (idx < 0) {
        if (type) {
          let arr = [...uidsArr, uid];
          window.localStorage.setItem('id_popup_merge', JSON.stringify(arr));
        }
        return false;
      } else {
        return true;
      }
    } else {
      if (type) {
        window.localStorage.setItem('id_popup_merge', JSON.stringify([uid]));
      }
      return false;
    }
  };

  const handleConfirmMergeVideo = () => {
    console.log(243, 'handleConfirmMergeVideo');
    // begin download audio and video

    if (videoRender && videoRender.length > 0) {
      if (!videoRender[0]?.file_id) {
        let dataMerge = {
          name: videoRender[0]?.child_name || '',
          template: videoRender[0]?.video_message_templete.code || 2,
          character:
            videoRender[0]?.character_pose.child_name === '차탄'
              ? 'chatan'
              : 'chuchu',
          video_id: videoRender[0]?.id || null,
          user_id: user?.id || null,
        };
        console.log(349, dataMerge);
        if (isStatusMergeVideo.type === ERROR_MERGE_VIDEO.DEVICE_DIFF.type) {
          ///remove video
          setIsStatusMergeVideo({
            ...isStatusMergeVideo,
            status: false,
            type: '',
            msg: '',
          });
          checkUidInLocalStorage(user?.id, true);
        } else {
          console.log(dataMerge, 'dataMerge');
          navigate(ROUTERS.VIDEO_COMPLETED, {
            state: {
              dataMerge,
            },
          });
        }
      }
    }
  };

  const handleUpdateApp = (url) => {
    console.log('handleUpdateApp');
    setPopupUpdateApp({
      ishow: false,
      url: '',
    });
    window.callOpenBrowserNative(url);
  };

  return (
    <MainLayout
      pageID={'main-page'} // pageID
      activeNav={'HOME'} // HOME | CAMERA | VIDEO | GIFTBOX | PHOTO
      displayBottomNav={true} // true | false
    >
      {/* <ModalSelect /> */}
      <HeaderHs1 handleOpenQRCode={() => handleOpenQRCode()} />
      <div className="wrapper">
        {/* CONTENT */}
        <div
          className={
            banners.length || isProcessingBanner
              ? 'header-main'
              : 'header-main background-main '
          }
        >
          <div className="header-main__box-point">
            <p className="nick-name">안녕하세요.</p>
            <div className="title-point">
              <span className="text-greeting text-truncate">
                {user?.nickname ? user?.nickname + '님!' : ''}
              </span>
              <span className="point-number">{priceFormat(point)}P</span>
              {/* <img
                src={IconNextPage}
                alt=""
                className="icon-point"
                onClick={goToGiftboxPoint}
              /> */}
              <span className="icon-point" onClick={goToGiftboxPoint}>
                <IconNextPage />
              </span>
            </div>
          </div>
          <HomeBanner
            isProcessing={isProcessingBanner}
            images={banners.map((e) => e)}
          />
        </div>
        <div className={`main-content ${isProcessingBanner ? 'mt-384' : ''}`}>
          <HomeAwards award={award} entries={entries} />
          {/* {award.id ? (
            <HomeAwards award={award} entries={entries} />
          ) : (
            <LoadingAward />
          )} */}

          {award.id && (
            <div className="box-btn">
              <button
                type="button"
                className="btn btn-rounded btn-block btn-primary btn-img"
                onClick={() => goToAward()}
              >
                랭킹 보러 가기
                {/* <img
                  className="img-next"
                  src={IconNextBtnW}
                  alt=""
                /> */}
                <span className="img-next">
                  <IconNextBtnW />
                </span>
              </button>
            </div>
          )}
          <HomeRecommendedVideo videos={recommend_videos} />
          <HomeAlbum />
          <HomeCategory />
          <HomeCharacter
            characters={user.favorite_characters}
            setPopupListChildren={setPopupListChildren}
          />
        </div>
        <HomeVoteAward />
      </div>
      <div className="list-children">
        <ListChildren
          handleListChildren={handleListChildren}
          popupListChildren={popupListChildren}
          childrens={nextInterestedContent}
        />
        <InterestedContent
          show={popupInterestedContent}
          submitInterestedContent={submitInterestedContent}
          characterModels={characterModels}
          idCharacterActive={(user?.favorite_characters || []).map((e) => e.id)}
          setPopupInterestedContent={setPopupInterestedContent}
        />
      </div>

      <DialogComponent
        id={`status-merge-video`}
        children={``}
        show={isStatusMergeVideo?.status || false}
        title={`알림`}
        closeBtn={isStatusMergeVideo?.btnClose || `취소`}
        handleClose={() => handleClose(isStatusMergeVideo?.type)}
        className={`status-merge-video`}
        customBtn={isStatusMergeVideo?.btnConfirm || '확인'}
        handleCustom={handleConfirmMergeVideo}
        classOverlay={'overlay-status-merge-video'}
      >
        <div className="content-dialog-merge-video">
          <div
            className="text"
            dangerouslySetInnerHTML={{
              __html: isStatusMergeVideo?.msg || '',
            }}
          >
            {/* <label className='text-push'>
                제작이 완료되면 push로 알려드립니다.
              </label> */}
          </div>
        </div>
      </DialogComponent>

      <DialogComponent
        id={`status-merge-video-cancel`}
        children={``}
        show={isCancelMergeVideo?.status || false}
        title={`알림`}
        closeBtn={`확인`}
        handleClose={handleCloseCancel}
        className={`status-merge-video`}
        classOverlay={'overlay-status-merge-video'}
      >
        <div className="content-dialog-merge-video">
          <div
            className="text"
            dangerouslySetInnerHTML={{
              __html: isCancelMergeVideo?.msg || '',
            }}
          >
            {/* <label className='text-push'>
              제작이 완료되면 push로 알려드립니다.
            </label> */}
          </div>
        </div>
      </DialogComponent>

      <DialogComponent
        id={`popup-update-version`}
        children={``}
        show={popupUpdateApp.ishow || false}
        title={`알림`}
        closeBtn={`확인`}
        handleClose={() => handleUpdateApp(popupUpdateApp.url)}
        className={`popup-update-version`}
        classOverlay={'overlay-popup-update-version'}
      >
        <div className="content-dialog-merge-video">
          <div className="text">
            새로운 버전의 스포키즈앱이 준비되었습니다.
            <br />
            앱스토어로 이동해 업데이트를 진행해주세요.
          </div>
        </div>
      </DialogComponent>

      {
        // (isLoadingCheckErrVideo || isProcessingVideoRender || isProcessingDel) && <Loading />
        isProcessingDel && <Loading />
      }
    </MainLayout>
  );
};

export default HomePageContainer;
